import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import ArmrestPickerButton from '../components/ArmrestPickerButton';
import {
	Platform,
	DeviceType,
	Orientation,
	WriteDirection,
	PopOver,
	ArmrestsByCover,
	CoverItem,
} from 'sofa-reborn-react';
import { setCurrentLightbox } from '../store/application/actions';
import { hidePopOver } from '../store/popOver/actions';
import { selectSceneItem } from '../store/scene/actions';
import { setSelectedArmrest } from '../store/armrest';
import { Product } from '@ikea-aoa/component-view-3d';

const ArmrestPickerButtonContainer: React.FC = () => {
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const orientation = useSelector<RootState, Orientation>((state) => state.deviceInfo.orientation);
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);
	const noValidConnection = useSelector<RootState, PopOver>(
		(state) => state.popOver.noValidConnection
	);
	const selectedCover = useSelector<RootState, CoverItem | null>(
		(state) => state.cover.selectedCover
	);
	const coverName = selectedCover?.coverName;
	const armrests = useSelector<RootState, ArmrestsByCover | null>(
		(state) => state.armrest.armrests
	);
	const selectedArmrest = useSelector<RootState, Product | null>(
		(state) => state.armrest.selectedArmrest
	);

	const dispatch = useDispatch<AppDispatch>();

	const onButtonClick = (): void => {
		if (noValidConnection.showPopOver) {
			dispatch(hidePopOver({ type: 'no-valid-connection' }));
		}
		dispatch(setCurrentLightbox('armrest-picker'));
		dispatch(selectSceneItem(null));
	};

	useEffect(() => {
		if (selectedCover?.coverName && armrests) {
			if (selectedArmrest && selectedArmrest.filter.color !== selectedCover.coverName) {
				const wide = selectedArmrest.modelId.includes('WIDE');
				const newArmrests = armrests[selectedCover.coverName];
				const { regularArmrest, wideArmrest } = newArmrests;
				if (newArmrests) {
					if (wide) {
						if (wideArmrest && wideArmrest !== selectedArmrest) {
							dispatch(setSelectedArmrest(wideArmrest, false));
						} else if (regularArmrest && regularArmrest !== selectedArmrest) {
							dispatch(setSelectedArmrest(regularArmrest, false));
							onButtonClick();
						}
					} else if (regularArmrest && regularArmrest !== selectedArmrest) {
						dispatch(setSelectedArmrest(newArmrests.regularArmrest, false));
					} else if (wideArmrest && wideArmrest !== selectedArmrest) {
						dispatch(setSelectedArmrest(wideArmrest, false));
						onButtonClick();
					}
				}
			}
		}
	}, [selectedCover]);

	return (
		<>
			{armrests && (
				<ArmrestPickerButton
					platform={platform}
					deviceType={deviceType}
					orientation={orientation}
					writeDirection={writeDirection}
					selectedArmrest={selectedArmrest}
					regularArmrest={coverName && armrests[coverName].regularArmrest}
					onButtonClick={(): void => onButtonClick()}
				></ArmrestPickerButton>
			)}
		</>
	);
};

export default ArmrestPickerButtonContainer;
